import axios from "axios";

import globalRouter from "../components/globalRouter";

// REACT_APP_API_URL já inclui o sufixo /api/v1 (ver .env e nginx).
// Em produção (container), o build assa "__BACKEND_API__" e o docker-entrypoint.sh
// substitui pelo valor real em runtime (uma imagem serve qualquer servidor).
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "__BACKEND_API__",
});

export default api;

api.interceptors.response.use(
  (response) => response,
  function (error) {
    switch (error.response?.status) {
      case 401:
        // Token inválido/expirado: limpa e volta pro login.
        document.cookie =
          "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        delete api.defaults.headers.common["Authorization"];
        if (globalRouter.navigate) {
          globalRouter.navigate("/login");
        } else {
          window.location.href = "/login";
        }
        break;
      case 402: {
        // Licença expirada ou inválida (middleware do backend standalone).
        const licenseError = {
          message: error.response?.data?.message || "Licença expirada",
          error: error.response?.data?.error || "Licença inválida",
          timestamp: new Date().toISOString(),
          app: error.response?.data?.app || "Hermes",
        };
        localStorage.setItem("licenseError", JSON.stringify(licenseError));
        if (globalRouter.navigate) {
          globalRouter.navigate("/license-expired");
        }
        break;
      }
      case 403:
        if (globalRouter.navigate) {
          globalRouter.navigate("/403");
        }
        break;
      default:
        return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

// Helpers de CRUD usados pelas telas do Hermes (contrato anubis).
// Listagem é via POST com corpo { limit, offset, order_by, order, query }.
export const get_all = async (
  endpoint,
  limit = 10,
  offset = 0,
  order_by = undefined,
  order = undefined,
  query = ""
) => {
  return await api.post(endpoint, { limit, offset, order_by, order, query });
};

export const get_one = async (endpoint, id) => {
  return await api.get(endpoint + "/" + id);
};

export const create = async (endpoint, data) => {
  return await api.post(endpoint, data);
};

export const update = async (endpoint, id, data) => {
  return await api.put(endpoint + "/" + id, data);
};

export const delete_one = async (endpoint, id) => {
  return await api.delete(endpoint + "/" + id);
};

export const action = async (endpoint, id, suffix, body = undefined) => {
  const path = id != null ? `${endpoint}/${id}/${suffix}` : `${endpoint}/${suffix}`;
  return await api.post(path, body ?? {});
};
